import { PriceSection, DiscountBadges } from './booking/PriceSection';
import { CalendarSection } from './booking/CalendarSection';
import { PriceBreakdown } from './booking/PriceBreakdown';
import { BookingActionButton } from './booking/BookingActionButton';
import { BankTransferSection } from './booking/BankTransferSection';
import { AirbnbLink, WhatsAppContactButton, AdminContactSection } from './booking/ContactSection';
import { GuestCounter } from './booking/GuestCounter';
import { PaymentMethods } from './booking/PaymentMethods';
import { GuestPhoneField } from './booking/GuestPhoneField';

export function BookingSidebar({
  property,
  selectedDates,
  onSelectDates,
  nights,
  total,
  deposit,
  depositLabel,
  guestCounts,
  maxGuests,
  onUpdateGuestCount,
  guestPhone,
  onGuestPhoneChange,
  couponCode,
  onCouponCodeChange,
  onValidateCoupon,
  validatingCoupon,
  appliedCoupon,
  onPayment,
  processingPayment,
  blockedDates,
  isDateBlocked,
  paymentInfo,
  copyToClipboard,
  bookingRequestStatus,
}) {
  return (
    <div className="lg:col-span-1">
      <div className="bg-white rounded-xl p-6 shadow-sm sticky top-24">
        <PriceSection property={property} />
        <DiscountBadges property={property} />

        <CalendarSection
          selectedDates={selectedDates}
          onSelectDates={onSelectDates}
          blockedDates={blockedDates}
          isDateBlocked={isDateBlocked}
        />

        <GuestCounter
          guestCounts={guestCounts}
          maxGuests={maxGuests}
          onUpdateGuestCount={onUpdateGuestCount}
        />

        <GuestPhoneField value={guestPhone} onChange={onGuestPhoneChange} />

        <PriceBreakdown
          property={property}
          nights={nights}
          total={total}
          deposit={deposit}
          depositLabel={depositLabel}
          appliedCoupon={appliedCoupon}
          couponCode={couponCode}
          onCouponCodeChange={onCouponCodeChange}
          onValidateCoupon={onValidateCoupon}
          validatingCoupon={validatingCoupon}
        />

        <BookingActionButton
          property={property}
          nights={nights}
          deposit={deposit}
          appliedCoupon={appliedCoupon}
          onPayment={onPayment}
          processingPayment={processingPayment}
          bookingRequestStatus={bookingRequestStatus}
        />

        {nights > 0 && bookingRequestStatus === 'approved' && (
          <BankTransferSection
            property={property}
            deposit={deposit}
            appliedCoupon={appliedCoupon}
          />
        )}

        <AirbnbLink property={property} />
        <WhatsAppContactButton property={property} />
        <AdminContactSection property={property} />

        {paymentInfo && (paymentInfo.holder_name || paymentInfo.mercado_pago?.alias || paymentInfo.ars?.cbu || paymentInfo.pyg?.bank || paymentInfo.brl?.pix_key) && (
          <PaymentMethods paymentInfo={paymentInfo} copyToClipboard={copyToClipboard} />
        )}
      </div>
    </div>
  );
}
